import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  status: null,
  message: null,
  data: null,
  type: null,
  isAuthenticatedUser: false
};

const userUpdateReducer = createReducer(initialState, {
  CLIENT_UPDATE_REQ: (state) => {
    state.loading = true;
    state.data = null;
  },
  CLIENT_UPDATE_FETCH_SUC: (state, actions) => {
    const payload = actions.payload;
    state.loading = false;
    state.status = payload.status;
    state.message = payload.message;
    state.data = payload.data;
  },
  CLIENT_UPDATE_ERROR: (state, actions) => {
    state.loading = false;
    state.status = null;
    state.message = null;
    state.data = null;
  },
});

export default userUpdateReducer;
